<template>
	<div class="page container">
		<div class="page__info">
			<div class="page__info--title">
				Approval queue
			</div>
		</div>
		<div class="page__nav-menu">
			<router-link
				class="page__nav-menu__link"
				activeClass="page__nav-menu__link-active"
				v-for="(link, key) in getLinks"
				:key="key"
				:to="link.route"
			>
				{{ link.text }}
			</router-link>
		</div>
		<div class="courses">
			<search-input
				@search="onSearch"
			/>
			<div class="courses__list">
				<v2-course-card
					v-for="course in getCourses"
					:key="course.id"
					:course="course"
					adminMode
				/>
			</div>
			<records-count
				:pagination="pagination"
				:total="totalItems"
			/>
			<pagination
				v-bind="pagination"
				@paginate="onPaginate"
			/>
		</div>
	</div>
</template>

<script>
	import SearchInput  from '@/components/ui/views/SearchInput';
	import V2CourseCard from '@/components/v2/courses/V2CourseCard.vue';
	import Pagination   from '@/components/ui/views/Pagination';
	import RecordsCount from '@/components/ui/views/RecordsCount';
	import api          from '@/services/api';

	export default {
		layout: 'v2default',

		metaInfo: {
			title: 'Approval queue'
		},
		components: {
			SearchInput,
			V2CourseCard,
			Pagination,
			RecordsCount
		},
		data: () => ({
			courses: [],
			searchString: '',
			pagination: {
				perPage: 			20,
				currentPage: 	1,
				totalPages: 	0
			},
			totalItems: 0
		}),
		computed: {
			getCourses () {
				if (!this.courses ||
						!this.courses.length) {
					return false;
				}
				return this.courses;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					},
					{
						path: '/admin/queue',
						text: 'Approval queue'
					},
					{
						path: '/admin/queue',
						text: 'Courses'
					}
				].filter(Boolean);
			},
			getLinks () {
				return [
					{
						text: 'Courses',
						route: '/admin/queue'
					},
					{
						text: 'Deal Packs',
						route: '/admin/queue/deal-packs'
					}
				];
			}
		},
		created: function () {
			this.setCourses();
		},
		methods: {
			onSearch (value) {
				this.searchString = value;
				this.setCourses();
			},
			onPaginate (value) {
				this.pagination.currentPage = value;
				this.setCourses();
			},
			async setCourses () {
				const response = await api.admin.getCourses({
					include:       'metadata',
					searchString:  this.searchString,
					approval:      'pending',
					page:          this.pagination.currentPage,
					per:           this.pagination.perPage
				});
				if (!response) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.totalItems = response.meta.totalItems;
				this.pagination.totalPages = response.meta.numPages;
				this.pagination.currentPage = response.meta.page;
				this.courses = response.results;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};
</script>

<style lang="scss" scoped>
	[data-element='text'] {
		font-size:rem(12);
		color:$c-text;
		margin: 0 0 20px 0;
	}

  .page {
		&__info {
			margin-bottom: 24px;
		}

		&__nav-menu {
			display: flex;
			gap: 12px;
			align-items: center;
			margin-bottom: 20px;
			@include font();

			&__link {
				padding: 5px 5px;
				box-sizing: border-box;
				font-size: 20px;
				line-height: 24px;
				color: $c-dark-navy;
				border-radius: 8px;
				transition: background 0.2s ease;

				&:hover {
					background: $c-white-d2;
				}

				&-active {
					border-bottom: 2px solid $c-dark-navy !important;
					border-radius: 8px 8px 0px 0px !important;
				}

			}
		}
	}

	.courses {
		display: grid;
		gap: 30px;

		&__list {
			display: grid;
			gap: 12px;
			grid-template-columns: 1fr 1fr 1fr;

			@media (max-width: 767px) {
				grid-template-columns: 1fr;
			}

			.course-card {
				width: 100%
			}
		}
	}
</style>
